// 导入 抽取的 请求对象
import ajaxRequest from '../utils/request';

const reFix = 'useradmin';
const home = 'useradmin/Home';

// 获取列表
export function getPmcIntroduceApi(params) {
  return ajaxRequest({
    url: reFix + '/PmcIntroduce',
    method: 'GET',
    params: { ...params },
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 获取统计数据
export function getStatisticsApi(params) {
  return ajaxRequest({
    url: reFix + '/PmcIntroduce/statistics',
    method: 'GET',
    params: { ...params },
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 获取登陆日志
export function getLoginLogApi(data) {
  return ajaxRequest({
    url: home + '/QueryWechatLoginLog',
    method: 'POST',
    data,
  });
}
